export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./exercisesResource.vue?vue&type=template&id=55abd118&"


//////////////////
// WEBPACK FOOTER
// ./src/components/resource/exercisesResource.vue?vue&type=template&id=55abd118&
// module id = null
// module chunks = 